export default __webpack_public_path__ + "static/media/refine-2.6d0f0459.webp";